import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
  };

  return (
    <div
      style={{
        position: "absolute",
        top: "20px",
        right: "30px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        zIndex: 1000,
      }}
    >
      <button
        onClick={() => changeLanguage("tr")}
        className="btn btn-link p-0"
        style={{
          fontSize: "22px",
          opacity: i18n.language === "tr" ? 1 : 0.4,
          transition: "opacity 0.2s ease",
        }}
        title="Türkçe"
      >
        🇹🇷
      </button>

      <button
        onClick={() => changeLanguage("en")}
        className="btn btn-link p-0"
        style={{
          fontSize: "22px",
          opacity: i18n.language === "en" ? 1 : 0.4,
          transition: "opacity 0.2s ease",
        }}
        title="English"
      >
        🇬🇧
      </button>
    </div>
  );
};

export default LanguageSwitcher;
